// Extracted from markdown.utils.ts so light consumers (format-compat, report utils) don't
// transitively import the remark/unified packages, which are ESM-only and unparseable by
// Jest's CJS transform. markdown.utils.ts re-exports this to preserve existing call sites.
export function isLikelyHtml(value: string | null | undefined): boolean {
  if (!value) return false;
  // Allow leading whitespace and any number of leading HTML comments, then
  // require a real tag head: <tagname[ attrs]> or <tagname/>.
  //
  // Accepts: "<p>...", "  <div>...", "<!-- generated --><p>..."
  // Rejects: "< 5 mg ibuprofen", "<-- ... -->", and "Summary:\n<p>..."
  //          (leading text is a backend contract bug, not HTML).
  // Rejects markdown documents that contain HTML islands further in the body —
  // those should still go through the markdown renderer.
  return /^\s*(?:<!--[\s\S]*?-->\s*)*<[a-z][a-z0-9]*\b[^<]*>/i.test(value);
}

/**
 * Drops orphan closing tags from the start of an HTML string, and the line break after them.
 *
 * AI output sometimes opens with a stray `</p>` (scribe 65607). `isLikelyHtml` then sees no
 * opening tag and the note goes to the markdown renderer, which prints every tag as text; and
 * even rendered as HTML, the orphan parses into an empty first paragraph. Strip it before
 * either decision. Indentation on the next line is kept, so indented markdown survives.
 * Linear time: every repeat has to begin with `</`, so there is only one way to match.
 */
export function stripLeadingClosingTags(value: string): string {
  return value.replace(/^(?:\s*<\/[a-z][\w:-]*\s*>)+[ \t]*(?:\r?\n)?/i, "");
}
